module.exports = __webpack_public_path__ + "static/img/info-1.afedbd9d.png";